<template>
  <div class="flex flex-col items-center">
    <div class="m-2">
      <img width="600" src="https://fantomwheelz.com/assets/images/the_team_headline_02.png" />
    </div>
    <div class="flex flex-col mt-2 mx-4 w-full md:w-3/5 mb-8">
       There's always a team behind every (great) project. Fantom Wheelz consists of two Nordic
       crypto believers. We've aped into many projects and we've seen even more... It's a wild
       wild west.
       <br /><br />
       But we hadn't seen anything like this before, so something had to be done. Meet the
       team behind the Fantom Wheelz.
       <br /><br />
       <div class="mx-auto grid grid-cols-1 md:grid-cols-2 mt-2 mb-0 mx-1">
            <div class="my-2 mx-8 flex leading-7 flex-col items-center">
                <div class="text-center text-2xl font-bold">Artist by talent</div>
                <img class="self-center" width="340" src="https://fantomwheelz.com/assets/images/the_helmets_sellek_01.png" />
                <br />
                SELLEK is building up a NFT resume using his graffiti artist background bringing a
                tongue-in-cheek street art vibe to the de-fi art scene. Illustrations and text based projects with
                a gritty, handmade look is what he is known for, but you can equally find him doing
                video based art outside of the crypto space. Likes to hang around the FTM family
                and be active in the community - loves to spread the #ftmfamily message. Loves SAAB.
            </div>
            <div class="my-2 mx-8 leading-7 flex flex-col items-center">
                <div class="text-center text-2xl font-bold">Coder by practice</div>
                <img width="300" src="https://fantomwheelz.com/assets/images/the_helmets_moose_01.png" />
                <br />
                MOOSE is a hired gun when it comes to coding. People pay, MOOSE codes. Language agnostic
                full stack dev with a hefty amount of blockchain experience. Closest to heart seems to
                be different web technologies, be it browser, mobile or somewhere in between. When
                not coding, MOOSE loves climbing in the great outdoors. Maximum grade around 8a/8A.
                When it comes to cars, Skyline and vanlife is close to MOOSE's heart.
            </div>
       </div>
       <div class="">
            <img width="1000" src="https://fantomwheelz.com/assets/images/the_pit_crew_headline_01.png" />
       </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { },
  components: {}
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/TeamPage.vue